export default {
  apiRegister: '/api/auth/register',
  apiLogin: '/api/auth/login',
  apiModules: '/api/modules',

  home: '/',
}
